import React from 'react';
import LiveEventsFetcher from './LiveEventsFetcher';
import Multilive from './Multilive';

export default function MultiliveFetcher() {
    return (
        <LiveEventsFetcher renderItem={(data) => <Multilive data={data} />} />
    );
}
